<template>
  <!-- 最顶部title -->
  <div class="liu pos-manage businesser">
    <mt-header fixed title="流量费明细" class="title1">
      <mt-button slot="left" icon="back" @click="onBackBtnClick">返回</mt-button>
      <mt-button slot="right" @click="visible.search=true">更多</mt-button>
    </mt-header>
    <!-- 页面主体 -->
    <div class="scroll-container" :style="customScrollHeight" v-infinite-scroll="getMoreMyData" :infinite-scroll-disabled="myData.scrollDisabled" infinite-scroll-distance="0">
      <!-- 空页 -->
      <div v-if="isShowEmptyData" />
      <!-- 无数据占位图 -->
      <div v-if="isShowNoData">
        <div class="no-data">
          <img src="../../assets/bitmap_datafee@3x.png" width="60%" />
          <div class="title-4">
            {{ emptyStartDate + " - " + emptyEndDate + " 暂无流量费" }}
          </div>
          <div class="title-4"> 点击右上角 <span @click="visible.search=true">更多</span> 查看更多流量费信息 </div>
        </div>
      </div>
      <!-- 列表 -->
      <div class="form bn-list mt-15 fee-list" v-if="isShowListData">
        <!-- <div class="form bn-list mt-15 fee-list"> -->
        <div class="bn-row fee-row" v-for="(item, index) in myData.list" :key="index">
          <div class="fee-svg">
            <svg-icon icon-class="datafee_detail" class-name="svg" />
          </div>
          <div class="info">
            <div class="name">
              <span class="info-name">{{item.userName}}<span v-if="item.userMobile">({{item.userMobile}})</span></span>
            </div>
            <div class="info-date">
              <span>扣费时间 {{item.realExeDate}}</span>
            </div>
            <div>
              <span class="info-date">生效时间 {{item.deductionPeriod}}</span>
            </div>
          </div>
          <div class="row-right">
            <span>+{{item.moneyStr}}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 筛选页内容 -->
    <mt-popup class="agent-popup" v-model="visible.search" position="right" :modal="false">
      <div class="agent-content">
        <!-- 标题 -->
        <mt-header fixed title="筛选" class="title2"></mt-header>
        <!-- 内容 -->
        <div class="popup-content">
          <!-- 注册时间 -->
          <div class="content-box fee-box">
            <div>
              <span>扣费日期</span>
            </div>
            <div class="no-border">
              <span class="date" @click="onSearchDateClick('startDate')">{{picker.startDateText}}</span>
              -
              <span class="date" @click="onSearchDateClick('endDate')">{{picker.endDateText}}</span>
            </div>
          </div>
        </div>
        <!-- 按钮 -->
        <div class="more-button">
          <span class="white" @click="onSearchBtnCancelClick">取消</span>
          <span class="blue" @click="onSearchBtnSubmitClick">确定</span>
        </div>
      </div>
    </mt-popup>
    <!-- 日期选择控件 -->
    <mt-datetime-picker ref="datePicker" type="date" :value="picker.selectedDate" :startDate="picker.startDate" :endDate="picker.endDate" year-format="{value} 年" month-format="{value} 月" date-format="{value} 日" @confirm="onDatePickerConfirm" />
  </div>
</template>

<script>
import { SucceedHandle2, NotSucceedHandle } from '@/api/handle';
import { CusToast, CusLoadingOpen, CusLoadingClose } from '@/utils/CustomToast';
import { formatDate } from '@/utils/utils';
import { GetDeductionMoneyPlanList } from '@/api/customer';
import SvgIcon from '@/components/SvgIcon';

export default {
  name: 'BusinesserList',
  components: { SvgIcon },
  data() {
    return {
      title: '流量费明细',
      // 列表数据模型
      myData: {
        list: [
          {
            userName: '张晓雅',
            userMobile: '0978',
            deductionPeriod: '2022-11-12 至 2023-11-09',
            realExeDate: '2022-11-12 12:14:45',
            moneyStr: '190.00',
          },
          {
            userName: '赵小熙',
            userMobile: '0978',
            deductionPeriod: '2022-11-12 至 长期',
            realExeDate: '2022-11-12 12:14:45',
            moneyStr: '130.00',
          },
          {
            userName: '沈晓棠',
            userMobile: '0978',
            deductionPeriod: '2022-11-12 至 2023-11-09',
            realExeDate: '2022-11-12 12:14:45',
            moneyStr: '140.00',
          },
        ],
        total: 2,
        scrollDisabled: true,
      },
      // 查询条件模型
      myParam: {
        endDate: '',
        pageNum: 1,
        pageSize: 12,
        startDate: '',
        feeExeType: -1,
        paymentType: -1,
        status: 1,
        h5Request: 1,
      },
      // 日期组件模型
      picker: {
        startDateBase: '',
        endDateBase: '',
        startDateText: '',
        endDateText: '',
        startDate: new Date(),
        endDate: new Date(),
        selectedDate: null,
        dateType: '',
      },
      // 显示开关模型
      visible: {
        search: false,
      },
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initData();
    });
  },
  computed: {
    customScrollHeight() {
      return `height:${window.innerHeight}px;`;
    },
    emptyStartDate() {
      return this.picker.startDateText.replace(/\-/g, '.');
    },
    emptyEndDate() {
      return this.picker.endDateText.replace(/\-/g, '.');
    },
    isShowNoData() {
      return this.myData.total === 0;
    },
    isShowEmptyData() {
      return this.myData.total === -1;
    },
    isShowListData() {
      return this.myData.total > 0;
    },
  },
  methods: {
    // 加载数据
    initData() {
      // 滚动条置顶
      window.scrollTo(0, 0);
      // 列表清空
      this.myData.list = [];
      // 页数置1
      this.myParam.pageNum = 1;
      // 加载数据
      this.getDateBase(() => {
        this.getMyData();
      });
    },
    // 通过接口获取数据
    getMyData(callback = null) {
      CusLoadingOpen();
      // 先设置禁止滚动加载数据
      this.myData.scrollDisabled = true;
      this.myParam.startDate = `${this.picker.startDateText} 00:00:00`;
      this.myParam.endDate = `${this.picker.endDateText} 23:59:59`;
      GetDeductionMoneyPlanList(this.myParam)
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              this.myData.total = res.total;
              this.myData.list.push(...res.data.deductionMoneyPlanListResponseList);
              this.myData.list.forEach(item => {
                if (item.userMobile) {
                  // 去手机号后4位
                  item.userMobile = item.userMobile.substr(item.userMobile.length - 4);
                }
              });
              // 通过记录条数list.length和数据总数total判断是否查询出所有数据
              // 如果记录条数小于数据总数，则证明没有查询出所有数据，设置允许滚动加载数据
              if (this.myData.list.length < this.myData.total) {
                this.myData.scrollDisabled = false;
              }
              callback && callback();
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 自动加载获取更多数据
    getMoreMyData() {
      // 通过记录条数list.length和数据总数total判断是否查询出所有数据
      // 如果记录条数小于数据总数，则证明没有查询出所有数据

      if (this.myData.list.length && this.myData.list.length < this.myData.total) {
        this.myParam.pageNum += 1;
        this.getMyData();
      }
    },
    // 代理商列表日期查询条件
    getDateBase(callback) {
      this.picker.startDateBase = new Date(new Date().setFullYear(new Date().getFullYear() - 1));
      this.picker.endDateBase = new Date();
      this.picker.startDateText = formatDate(this.picker.startDateBase);
      this.picker.endDateText = formatDate(this.picker.endDateBase);
      callback && callback();
    },
    // 返回单击事件
    onBackBtnClick() {
      window.location.href = 'protocol://android';
    },
    // 查询-日期框单击事件
    onSearchDateClick(val) {
      // 设置日期类型
      this.picker.dateType = val;
      // 根据选择的日期类型判断
      switch (val) {
        // 开始日期
        case 'startDate':
          // 日期框显示的最大日期：2000-01-01
          this.picker.startDate = new Date('2000-01-01');
          // 日期框显示的最小日期：今天
          this.picker.endDate = new Date();
          // 日期框显示的选中日期：默认查询开始日期
          this.picker.selectedDate = new Date(this.picker.startDateText);
          break;
        // 结束日期
        case 'endDate':
          // 日期框显示的最大日期：默认查询开始日期
          this.picker.startDate = new Date(this.picker.startDateText);
          // 日期框显示的最小日期：今天
          this.picker.endDate = new Date();
          // 日期框显示的选中日期：默认查询结束日期
          this.picker.selectedDate = new Date(this.picker.endDateText);
          break;
      }
      this.$refs.datePicker.open();
    },
    // 查询-取消按钮单击事件
    onSearchBtnCancelClick() {
      this.visible.search = false;
    },
    // 查询-确定按钮单击事件
    onSearchBtnSubmitClick() {
      // 1.滚动条置顶
      window.scrollTo(0, 0);
      // 2.关闭查询窗口
      this.visible.search = false;
      // 3.打开滚动刷新
      this.myData.scrollDisabled = true;
      // 4.重置列表数据
      this.myData.list = [];
      // 5.重置翻页页数
      this.myParam.pageNum = 1;
      // 6.重置总数
      this.myData.total = -1;
      // 7. 加载数据
      this.getMyData();
    },
    // 日期控件-确定事件
    onDatePickerConfirm(val) {
      // 根据选择的日期类型判断
      switch (this.picker.dateType) {
        // 开始日期
        case 'startDate':
          // 如果开始日期选择了一个大于当前查询结束日期
          if (val > new Date(this.picker.endDateText)) {
            // 则将查询结束日期自动置为今天的日期
            this.picker.endDateText = formatDate(new Date());
          }
          this.picker.startDateText = formatDate(val);
          break;
        // 结束日期
        case 'endDate':
          this.picker.endDateText = formatDate(val);
          break;
      }
    },
  },
};
</script>
